// dependencies
import React from "react";
import { Link } from "yarrr";

// components
import { CustomStringCellEditor } from "./custom-string-cell-editor";

// styles
import css from "../CompanyFeatureFlags.styl";

export const getColumns = ({ companyId }) => {
	const columns = [
		{
			field: "name",
			headerName: "Name",
			cellRenderer: ({ data, value }) => {
				return (
					<Link className={css.link} href={`/companies/${companyId}/feature-flags/${data._id}`}>
						{value}
					</Link>
				);
			},
		},
		{
			field: "category",
			headerName: "Category",
		},
		{
			field: "type",
			headerName: "Type",
		},
		{
			field: "value",
			headerName: "Value",
			editable: true,
			cellEditorSelector: ({ data }) => {
				if (data.type === "boolean") {
					return {
						component: "agSelectCellEditor",
						params: {
							values: ["Hidden", "Visible"],
						},
					};
				}

				if (data.type === "number") {
					return {
						component: "agNumberCellEditor",
					};
				}

				return {
					component: CustomStringCellEditor,
					popup: true,
				};
			},

			/**
			 * This bypasses the default value parser because it is too strict.
			 */
			valueParser: ({ newValue }) => {
				return newValue;
			},
		},
	];

	return columns;
};
